import _ from "lodash";
import React from "react";
import { colors } from "Constants";
import { AddAssessment, AddNote, TagElements } from "SvgComponents";
import { getIconList } from "GenericTableEditor/IconPicker/IconPickerUtils";

import {
  LoudspeakerOutlined,
  AtlOutlined,
  PageFoldPortraitOutlined,
  SqauresCircleOutlined,
  UserReflectionOutlined,
  CommentQuestionMarkOutlined,
  PuzzleCircleOutlined,
  HeadOutlined,
  SquareCircleOutlined,
  FileNotFoundOutlined,
  ClassProgressOutlined,
  SpiralBookStarOutlined,
  ClipboardPencilLinesOutlined,
  HierarchyOutlined,
  StructureOutlined,
  AssessmentOutlined,
  PuzzlePiecesOutlined,
  PageBookmarkOutlined,
  PuzzlePieceOutlined,
  ChecklistOutlined,
  HeadLeafOutlined,
  ResourceOutlined,
  MultipleUsersOutlined,
  GlobeOutlined,
  HandOutlined,
  HeartLikeOutlined,
  HamburgerOutlined,
  CornersOutOutlined,
  GridOutlined,
  ClipboardOutlined,
  MicrophoneOutlined,
  PlaceholderFileOutlined,
  PlaceholderFileUpArrowOutlined,
  AssessmentandEvaluationOutlined,
  ScoreBasedAssessmentOutlined,
  CommentTextOutlined,
  AssessmentApplicableOutlined,
  GoalsOutlined,
  NoteOutlined,
  OpenBookOutlined,
  ClockOutlined,
  UnitPlanOutlined,
  ListNumberedOutlined,
  VolumeLowOutlined,
  WorksheetClipboardOutlined,
  CalendarScheduleOutlined,
  ListBulletedOutlined,
  CommentCircleLeftOutlined,
  StudentEvaluateOutlined,
  PageSquareOutlined,
  AddOutlined,
  AssessmentAddOutlined,
  UserProfileOutlined,
  StudentOutlined,
  WeightOutlined,
  ChatLeftDotsOutlined,
  StaffMemberOutlined,
  LanguageOutlined,
  UserSpeakingOutlined,
  AiStarsOutlined,
  ChatTextLeftOutlined,
  SmileySatisfiedOutlined,
  CommentRemarkOutlined,
  TagOutlined,
  StarsTwoFilled,
  MoveToAssignedCircleOutlined,
  SpiralBookLinesOutlined,
  DashboardOutlined,
  PageAPlusOutlined,
  WorkbookOutlined,
  SortOutlined,
} from "@toddle-edu/ds-icons";
import { Avatar } from "@toddle-edu/ds-web";

const iconListForPicker = getIconList();

const PlannerIcon = ({ icon, color }) => {
  return (
    <Avatar
      icon={icon}
      size="medium"
      shape="square"
      theme="light"
      color={color}
      iconType="icon"
      dsVersion="2.0"
    />
  );
};

export const PlannerIconsV2 = props => {
  switch (props.icon) {
    case "PicnActions":
    case "PicnLOI":
      return (
        <PlannerIcon icon={<LoudspeakerOutlined {...props} />} color="blue" />
      );
    case "PicnATL":
      return <PlannerIcon icon={<AtlOutlined {...props} />} color="blue" />;

    case "PicnKeyConcepts":
      return (
        <PlannerIcon
          icon={<PuzzleCircleOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnRelatedConcepts":
      return <PlannerIcon icon={<SquareCircleOutlined {...props} />} />;

    case "PicnLP":
      return <PlannerIcon icon={<HeadOutlined {...props} />} color="pink" />;

    case "PicnTheme":
      return <PlannerIcon icon={<GridOutlined {...props} />} color="pink" />;
    case "PicnPriorLearning":
      return (
        <PlannerIcon icon={<ChecklistOutlined {...props} />} color="yellow" />
      );
    case "PicnTQues":
      return (
        <PlannerIcon
          icon={<CommentQuestionMarkOutlined {...props} />}
          color="blue"
        />
      );
    case "PicnLearningGoals":
      return <PlannerIcon icon={<GoalsOutlined {...props} />} color="pink" />;
    case "PicnCentralIdea":
      return (
        <PlannerIcon
          icon={<PuzzlePiecesOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnConnections":
      return (
        <PlannerIcon icon={<StructureOutlined {...props} />} color="pink" />
      );
    case "PicnInReflections":
      return (
        <PlannerIcon
          icon={<UserReflectionOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnLE":
      return (
        <PlannerIcon icon={<HeadLeafOutlined {...props} />} color="yellow" />
      );
    case "PicnOnAssmnts":
      return (
        <PlannerIcon
          icon={<AssessmentandEvaluationOutlined {...props} />}
          color="blue"
        />
      );
    case "PicnResources":
      return (
        <PlannerIcon icon={<ResourceOutlined {...props} />} color="blue" />
      );
    case "PicnOnReflections":
    case "PicnPriorReflection":
    case "ReflectionPriorToTeachingDuotone":
      return (
        <PlannerIcon
          icon={<UserReflectionOutlined {...props} />}
          color="pink"
        />
      );
    case "PicnSelfAssmnt":
      return (
        <PlannerIcon icon={<ClassProgressOutlined {...props} />} color="blue" />
      );
    case "PicnStudentAgency":
      return (
        <PlannerIcon
          icon={<MultipleUsersOutlined {...props} />}
          color="yellow"
        />
      );
    case "AddAssessment":
      return (
        <AddAssessment
          width={32}
          height={32}
          fill={colors.neutral400}
          {...props}
        />
      );
    case "AddNote":
      return (
        <AddNote width={32} height={32} fill={colors.neutral400} {...props} />
      );
    case "TagElements":
      return (
        <TagElements
          width={32}
          height={32}
          fill={colors.neutral400}
          {...props}
        />
      );

    case "PicnATLV2":
      return <PlannerIcon icon={<AtlOutlined {...props} />} color="pink" />;
    case "PicnContent":
      return (
        <PlannerIcon
          icon={<PageFoldPortraitOutlined {...props} />}
          color="blue"
        />
      );
    case "Differentiations":
      return <PlannerIcon icon={<SqauresCircleOutlined {...props} />} />;
    case "PicnDifferentiations":
      return (
        <PlannerIcon
          icon={<SqauresCircleOutlined {...props} />}
          color="violet"
        />
      );
    case "PicnFormative":
      return (
        <PlannerIcon
          icon={<AssessmentApplicableOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnGlobalContext":
      return <PlannerIcon icon={<GlobeOutlined {...props} />} color="yellow" />;
    case "PicnInquiryQues":
      return (
        <PlannerIcon
          icon={<CommentQuestionMarkOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnKeyConceptsV2":
      return (
        <PlannerIcon
          icon={<PuzzleCircleOutlined {...props} />}
          color="violet"
        />
      );
    case "PicnLPA":
      return <PlannerIcon icon={<HeadOutlined {...props} />} color="violet" />;
    case "PicnLearningStandards":
      return (
        <PlannerIcon icon={<ListNumberedOutlined {...props} />} color="blue" />
      );
    case "PicnObjective":
    case "ObjectivesDuotoneViolet":
      return <PlannerIcon icon={<GoalsOutlined {...props} />} color="violet" />;
    case "PicnRelatedConceptsV2":
      return (
        <PlannerIcon
          icon={<SquareCircleOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnStatementOfInquiry":
      return (
        <PlannerIcon icon={<FileNotFoundOutlined {...props} />} color="blue" />
      );
    case "PicnSubjectFocus":
      return (
        <PlannerIcon
          icon={<SpiralBookStarOutlined {...props} />}
          color="pink"
        />
      );
    case "PicnSummative":
      return (
        <PlannerIcon
          icon={<ClipboardPencilLinesOutlined {...props} />}
          color="yellow"
        />
      );

    case "PicnInterdisCriteria":
      return (
        <PlannerIcon icon={<HierarchyOutlined {...props} />} color="blue" />
      );
    case "PicnInterLearnExpTeachStrat":
      return (
        <PlannerIcon icon={<StructureOutlined {...props} />} color="yellow" />
      );
    case "PicnLearnExpTeachStrat":
    case "LeAndTeachingStrategiesDuotonePink":
    case "PicnLEV2":
      return (
        <PlannerIcon icon={<AssessmentOutlined {...props} />} color="pink" />
      );
    case "LearnExpTeachStrat":
      return <PlannerIcon icon={<AssessmentOutlined {...props} />} />;
    case "Prog":
      return <ClassProgressOutlined {...props} />;
    case "PicnPurposeIntegration":
      return (
        <PlannerIcon icon={<PuzzlePiecesOutlined {...props} />} color="blue" />
      );
    case "PicnDuringReflection":
      return (
        <PlannerIcon
          icon={<UserReflectionOutlined {...props} />}
          color="violet"
        />
      );
    case "PicnDisciplinarySubGeneric":
      return (
        <PlannerIcon
          icon={<PageBookmarkOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnAssessments":
      return (
        <PlannerIcon
          icon={<AssessmentandEvaluationOutlined {...props} />}
          color="yellow"
        />
      );
    case "PicnFormsIntegration":
      return (
        <PlannerIcon icon={<PuzzlePieceOutlined {...props} />} color="pink" />
      );
    case "PicnAfterReflection":
    case "ReflectionAfterTeachingDuotone":
      return (
        <PlannerIcon
          icon={<UserReflectionOutlined {...props} />}
          color="blue"
        />
      );
    case "ObjectivesBlueDuotone":
      return <PlannerIcon icon={<GoalsOutlined {...props} />} color="blue" />;
    case "PicnUnitDetails":
      return (
        <PlannerIcon
          icon={<SpiralBookLinesOutlined {...props} />}
          color="yellow"
        />
      );
    case "LearnerProfileDuotoneGreen":
      return <PlannerIcon icon={<HeadOutlined {...props} />} color="teal" />;
    case "HandDuotonePink":
      return <PlannerIcon icon={<HandOutlined {...props} />} color="pink" />;
    case "HeartDuotoneBlue":
      return (
        <PlannerIcon icon={<HeartLikeOutlined {...props} />} color="blue" />
      );
    case "HamburgerOutlined":
      return <HamburgerOutlined {...props} />;
    case "CornersOutOutlined":
      return <CornersOutOutlined {...props} />;
    case "GridOutlined":
      return <GridOutlined {...props} />;
    case "ClipboardOutlined":
      return <ClipboardOutlined {...props} />;
    case "MicrophoneOutlined":
      return <MicrophoneOutlined {...props} />;
    case "PlaceholderFileOutlined":
      return <PlaceholderFileOutlined {...props} />;
    case "PlaceholderFileUpArrowOutlined":
      return <PlaceholderFileUpArrowOutlined {...props} />;
    case "AssessmentandEvaluationOutlined":
      return <AssessmentandEvaluationOutlined {...props} />;
    case "ScoreBasedAssessmentOutlined":
      return <ScoreBasedAssessmentOutlined {...props} />;
    case "CommentTextOutlined":
      return <CommentTextOutlined {...props} />;
    case "AssessmentApplicableOutlined":
      return <AssessmentApplicableOutlined {...props} />;
    case "GoalsOutlined":
      return <GoalsOutlined {...props} />;
    case "NoteOutlined":
      return <NoteOutlined {...props} />;
    case "OpenBookOutlined":
      return <OpenBookOutlined {...props} />;
    case "ClockOutlined":
      return <ClockOutlined {...props} />;
    case "UnitPlanOutlined":
      return <UnitPlanOutlined {...props} />;
    case "ListNumberedOutlined":
      return <ListNumberedOutlined {...props} />;
    case "AssessmentOutlined":
      return <AssessmentOutlined {...props} />;
    case "VolumeLowOutlined":
      return <VolumeLowOutlined {...props} />;
    case "WorksheetClipboardOutlined":
      return <WorksheetClipboardOutlined {...props} />;
    case "CalendarScheduleOutlined":
      return <CalendarScheduleOutlined {...props} />;
    case "ListBulletedOutlined":
      return <ListBulletedOutlined {...props} />;
    case "CommentCircleLeftOutlined":
      return <CommentCircleLeftOutlined {...props} />;
    case "StudentEvaluateOutlined":
      return <StudentEvaluateOutlined {...props} />;
    case "PageSquareOutlined":
      return <PageSquareOutlined {...props} />;
    case "AddOutlined":
      return <AddOutlined {...props} />;
    case "AssessmentAddOutlined":
      return <AssessmentAddOutlined {...props} />;
    case "UserProfileOutlined":
      return <UserProfileOutlined {...props} />;
    case "StudentOutlined":
      return <StudentOutlined {...props} />;
    case "WeightOutlined":
      return <WeightOutlined {...props} />;
    case "ChatLeftDotsOutlined":
      return <ChatLeftDotsOutlined {...props} />;
    case "StaffMemberOutlined":
      return <StaffMemberOutlined {...props} />;
    case "ChatTextLeftOutlined":
      return <ChatTextLeftOutlined {...props} />;
    case "LanguageOutlined":
      return <LanguageOutlined {...props} />;
    case "UserSpeakingOutlined":
      return <UserSpeakingOutlined {...props} />;
    case "AiStarsOutlined":
      return <AiStarsOutlined {...props} />;
    case "SmileySatisfiedOutlined":
      return <SmileySatisfiedOutlined {...props} />;
    case "CommentRemarkOutlined":
      return <CommentRemarkOutlined {...props} />;
    case "TagOutlined":
      return <TagOutlined {...props} />;
    case "StarsTwoFilled":
      return <StarsTwoFilled {...props} />;
    case "MoveToAssignedCircleOutlined":
      return <MoveToAssignedCircleOutlined {...props} />;
    case "SpiralBookLines":
      return <SpiralBookLinesOutlined {...props} />;
    case "DashboardOutlined":
      return <DashboardOutlined {...props} />;
    case "PageAplusOutlined":
      return <PageAPlusOutlined {...props} />;
    case "ResourceOutlined":
      return <ResourceOutlined {...props} />;
    case "PageFoldPortraitOutlined":
      return <PageFoldPortraitOutlined {...props} />;
    case "WorkbookOutlined":
      return <WorkbookOutlined {...props} />;
    case "SortOutlined":
      return <SortOutlined {...props} />;
    default:
      return _.get(iconListForPicker, `${props.icon}.component`, null);
  }
};

PlannerIconsV2.defaultProps = {
  icon: "",
  size: "xx-small",
  variant: "default",
  hasBackground: false,
};
